import React from 'react';

import defaultLocale from './defaultLocale';

const LocaleContext = React.createContext(defaultLocale);

export type Locale = typeof defaultLocale;

export default LocaleContext;
